export default __webpack_public_path__ + "media/images/ico-psa-badge-35642b6f92ea0ad94c2ea7d69250ff38.svg";